<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "StatusIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
